import type { Izin } from '@nero/shared';
import type { SimgeAdi } from './bilesenler/Simge.js';

/**
 * MENÜ
 *
 * Kasıtlı olarak kısa. Birbirine yakın işler tek bölümde toplandı:
 *  · Müşteriler ve Araçlar tek ekranda (araç zaten müşteriye bağlı)
 *  · Kasa ve Cari tek ekranda
 *  · Stok, Hizmetler ve kritik seviye tek ekranda
 * Personelin görmediği bölüm menüde de görünmez.
 */
export interface MenuOge {
  yol: string;
  ad: string;
  /** Telefonun alt çubuğunda kullanılan kısa ad. */
  kisaAd?: string;
  simge: SimgeAdi;
  izin: Izin;
  /** Telefonda alt çubukta yer alır. */
  altCubuk?: boolean;
  grup: 'gunluk' | 'arac' | 'yonetim';
}

export const MENU: MenuOge[] = [
  { yol: '/', ad: 'Ana Sayfa', kisaAd: 'Ana sayfa', simge: 'ana-sayfa', izin: 'is_emri.goruntule', grup: 'gunluk', altCubuk: true },
  { yol: '/is-emirleri', ad: 'İş Emirleri', kisaAd: 'İş emri', simge: 'is-emri', izin: 'is_emri.goruntule', grup: 'gunluk', altCubuk: true },
  { yol: '/musteriler', ad: 'Müşteriler', kisaAd: 'Müşteri', simge: 'musteri', izin: 'musteri.goruntule', grup: 'gunluk', altCubuk: true },
  { yol: '/katalog', ad: 'Fiyat Kataloğu', kisaAd: 'Fiyat', simge: 'fiyat', izin: 'fiyat.goruntule', grup: 'gunluk', altCubuk: true },
  /* Kasa menüsü DAR izne bakar: personel girdi/çıktı yazabildiği için
     ekranı açabilmeli. Yöneticide bütün izinler olduğu için onun için
     bir şey değişmez; personel ise ekranı açar ama toplam/bakiye
     kutularını görmez (bkz. Kasa.tsx · finansGor). */
  { yol: '/kasa', ad: 'Kasa', simge: 'kasa', izin: 'kasa.kayit', grup: 'gunluk' },
  { yol: '/stok', ad: 'Stok', simge: 'stok', izin: 'stok.goruntule', grup: 'gunluk' },

  { yol: '/log-analiz', ad: 'Log Analiz', simge: 'log', izin: 'log.kullan', grup: 'arac' },
  { yol: '/post-studio', ad: 'Post Studio', simge: 'post', izin: 'post.kullan', grup: 'arac' },

  { yol: '/yonetici', ad: 'Yönetici', simge: 'yonetici', izin: 'rapor.goruntule', grup: 'yonetim' },
  { yol: '/ayarlar', ad: 'Ayarlar', simge: 'ayar', izin: 'is_emri.goruntule', grup: 'yonetim' },
];

export const GRUP_ADI: Record<MenuOge['grup'], string> = {
  gunluk: 'Günlük iş',
  arac: 'Araçlar',
  yonetim: 'Sistem',
};
